import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";

export default function TagInput({ tags, onChange, placeholder = "Type and press Enter", testid = "tag-input" }) {
  const [val, setVal] = useState("");
  const add = () => {
    const t = val.trim();
    if (t && !tags.includes(t)) onChange([...tags, t]);
    setVal("");
  };
  return (
    <div className="space-y-2">
      <Input
        value={val}
        onChange={(e) => setVal(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); } }}
        onBlur={add}
        placeholder={placeholder}
        data-testid={testid}
      />
      {tags.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {tags.map((t, i) => (
            <Badge key={i} variant="secondary" className="pl-3 pr-1.5 py-1 bg-navy/5 text-navy border border-navy/10" data-testid={`${testid}-tag-${i}`}>
              {t}
              <button type="button" onClick={() => onChange(tags.filter((_, idx) => idx !== i))} className="ml-1.5 hover:text-red-600">
                <X className="w-3 h-3" />
              </button>
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
}
